import { Post } from '@/model/data-object/Post'

export class PostMeta {
  parent?: Post
  position = 0
  isNew = false
  blockedByUser = false
  statsLoaded = false
}
